import GoogleMapsDevices from "components/homepage/googleMapsDevices";
import React, { Component } from "react";
import "scss/screens/homepage/machineStatusOverview.scss";
import { Button, Form, Select } from "semantic-ui-react";
import { HomepageContext } from "context/homepageProvider";

export default class MachineStatusOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchModel: "",
      maintenanceList: [],
      serviceList: [],
      serviceCountList: [],
    };
  }

  componentDidMount() {
    this.getAllLinkDevice({ name: "", level: -1 });
    const data = {
      state: ["contacted", "draft", "contact_fail", "later", "process"],
      pic: null,
      uid: null,
    };
    this.setDeviceData(data);
    this.getService();
    this.getServiceCount();
  }

  setDeviceData = async (data) => {
    await this.context.getMaintenances(data);
    this.setState({
      maintenanceList: this.context.maintenanceList.slice(
        this.state.begin,
        this.state.end
      ),
    });
      // console.log("MAdata", this.state.maintenanceList)
  };

  getService = async () => {
    await this.context.getService();
    this.setState({
      serviceList: this.context.serviceList
    });
    console.log("SVdata", this.state.serviceList)
  };

  getAllLinkDevice = async (data) => {
    await this.context.getAllLinkDevice(data);
    this.setState({
      devicesList: this.context.allDevicesList.slice(
        this.state.begin,
        this.state.end
      ),
    });
    console.log("allDevicesList", this.state.devicesList)
    this.countCautionLevels();
  };

  countCautionLevels = async (data) => {
    await this.context.getAllLinkDevice(data);
    
    const allDevicesList = this.context.allDevicesList;

    const countCautionLevel0 = allDevicesList.filter(device => device.caution_level === 0).length;
    const countCautionLevel1 = allDevicesList.filter(device => device.caution_level === 1).length;
    const countCautionLevel2 = allDevicesList.filter(device => device.caution_level === 2).length;
    const countCautionLevel3 = allDevicesList.filter(device => device.caution_level === 3).length;

    console.log("Caution Level 0:", countCautionLevel0);
    console.log("Caution Level 1:", countCautionLevel1);
    console.log("Caution Level 2:", countCautionLevel2);
    console.log("Caution Level 3:", countCautionLevel3);

    this.setState({
      devicesList: allDevicesList.slice(this.state.begin, this.state.end),
      countCautionLevel0,
      countCautionLevel1,
      countCautionLevel2,
      countCautionLevel3,
    });
};


  getServiceCount = async () => {
    let result = await this.context.getServiceCount();
    this.setState({
      serviceCountList: result,
    });
    console.log("SVCountdata", this.state.serviceCountList);
  };
  
  

  // เช็ค DataClient ถ้ามีข้อมูลให้ไปดึง api จาก device
  // fetchDataClient = async () => {
  //   const clientResponse = await axios.get(`${API_URL}/mqtt/clients`, {
  //     headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
  //   });

  //   if (clientResponse != null) {
  //     this.setState({ deviceDataClient: clientResponse.data.data });
  //   }
  // }
  
  createStatusSummary = () => {
    return (
      <>
        <div className="status">
          <a href={`/device-status/${0}`}>
            <div className="status-green">
              <div className="status-green-title">
                จำนวนเครื่องพร้อมใช้งาน
              </div>
              <div className="status-green-amount">
              {this.state.countCautionLevel0}
              </div>
            </div>
          </a>

          <a href={`/device-status/${1}`}>
            <div className="status-orange">
              <div className="status-orange-title">
                จำนวนเครื่องเตรียมซ่อม
              </div>
              <div className="status-orange-amount">
                {this.state.countCautionLevel1}
              </div>
            </div>
          </a>

          <a href={`/device-status/${2}`}>
            <div className="status-red">
              <div className="status-red-title">
                จำนวนเครื่องถึงกำหนดซ่อม
              </div>
              <div className="status-red-amount">
              {this.state.countCautionLevel2}
              </div>
            </div>
          </a>

          <a href={`/device-status/${3}`}>
            <div className="status-black">
              <div className="status-black-title">
                จำนวนเครื่องเลยกำหนดซ่อม
              </div>
              <div className="status-black-amount">
                {this.state.countCautionLevel3}
              </div>
            </div>
          </a>

        </div>
      </>
    );
  };

  createSearchDevices = () => {
    const { searchModel } = this.state;
    const devicesOptions = [
      { key: "all", text: "ทั้งหมด", value: "" },
      { key: "colper-5000k", text: "COLPER-5000K", value: "colper-5000k" },
      { key: "acr-100plus", text: "ACR-100PLUS", value: "acr-100plus" },
      { key: "MG600S", text: "MG600S", value: "MG600S" },
    ];
    return (
      <>
        <div className="search">
          <Form>
            <Form.Group inline>
              <Form.Field
                control={Select}
                options={devicesOptions}
                placeholder="ทั้งหมด"
                search
                value={searchModel}
                onChange={(e, { value }) =>
                  this.setState({ searchModel: value })
                }
              />
              <Button
                color="blue"
                onClick={() =>
                  this.context.getMachineStatusOverview({ model: searchModel })
                }>ค้นหา
              </Button>
            </Form.Group>
          </Form>
        </div>
      </>
    );
  };

  render() {
    return (
      <div className="machine">
        {this.createStatusSummary()}
        {this.createSearchDevices()}
        <GoogleMapsDevices />
      </div>
    );
  }
}

MachineStatusOverview.contextType = HomepageContext;
